import './item-search-screen.scss';

import Component from 'vue-class-component';

import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { ItemDataStore } from '@skinsoft/entity';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { SearchFeaturedList, TitleClickAction } from '@skinsoft/ui';

import { SearchHeader } from '@skinsoft/search/src/search-header';

declare const ITEM_SORTING_ENTITY_FIELDS: any[]
declare const OFFLINE_ITEM_SORTING_ENTITY_FIELDS: any[]

@Component({
    components: {
        sSearchFeaturedList: SearchFeaturedList,
        sSearchHeader: SearchHeader
    },
    props: ['targetRouteName', 'creationTargetRouteName', 'canCreateObject', 'displayedButtons', 'onlyNewItems', 'titleClickAction'],
    template: require('./item-search-screen.html')
})
export class ItemSearchScreen extends ReactiveVue {

    public targetRouteName: string
    public creationTargetRouteName: string

    private sortingEntityFields: any[] = [];

    private canCreateObject: boolean;
    private displayedButtons: any[];
    private onlyNewItems: boolean;
    private titleClickAction: TitleClickAction

    private loadingItemCreation = false;

    private spinnerIcon = faCircleNotch;

    private $itemDataStore: ItemDataStore;

    public mounted() {
        if(window.navigator.onLine) {
            this.sortingEntityFields = ITEM_SORTING_ENTITY_FIELDS
        } else {
            this.sortingEntityFields = OFFLINE_ITEM_SORTING_ENTITY_FIELDS
        }

        window.addEventListener('online', this.updateSortingFields)
        window.addEventListener('offline', this.updateSortingFields)
    }

    public createNewItem() {
        this.loadingItemCreation = true
        if (window.navigator.onLine) {
            this.$itemDataStore.create({}, {}).subscribe(this.getToNewItem)
        } else {
            const currentInstitution: string = localStorage.getItem('institution') as string
            this.$itemDataStore.createOffline({
                institutionCreation: currentInstitution
            }).subscribe(this.getToNewItem)
            
        }
    }

    public getToNewItem(item: {id: string}) {
        const path = this.creationTargetRouteName ? this.creationTargetRouteName : this.targetRouteName
        this.$router.push({name: path, params: {itemId: item.id}, query: {imageChoice: 'true'}})
    }

    private updateSortingFields() {
        if(window.navigator.onLine) {
            this.sortingEntityFields = ITEM_SORTING_ENTITY_FIELDS
        } else {
            this.sortingEntityFields = OFFLINE_ITEM_SORTING_ENTITY_FIELDS
        }
    }
}